import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { trackEvent } from '@shared/utils';
import { chatbotState } from './chatBotState';

export const useChatbotControls = () => {
  const [state, setState] = useRecoilState(chatbotState);

  const openChat = useCallback(
    ({ initialMessage }: { initialMessage?: string } = {}) => {
      setState({
        isOpen: true,
        initialMessage,
      });
      trackEvent('chatbot_opened');
    },
    [setState]
  );

  const closeChat = useCallback(() => {
    setState({
      isOpen: false,
      initialMessage: undefined,
    });
  }, [setState]);

  const toggleChat = useCallback(() => {
    if (!state.isOpen) trackEvent('chatbot_opened');
    setState((prev) => ({
      isOpen: !prev.isOpen,
      initialMessage: prev.isOpen ? undefined : prev.initialMessage,
    }));
  }, [setState, state.isOpen]);

  return {
    isOpen: state.isOpen,
    initialMessage: state.initialMessage,
    openChat,
    closeChat,
    toggleChat,
  };
};
